import React, { useState } from "react";
import {
  Box,
  Button,
  TextInput,
  Layer,
  Heading,
  Notification,
  Spinner,
  Text,
} from "grommet";
import axios from "axios";
import API_URL from "../../config/config";
import { useNavigate } from "react-router-dom";

export const SendInvite = ({
  manager_id,
  groupId,
  onUserAdded,
  isOpen,
  onClose,
}) => {
  const group_id = groupId || "";
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate();

  const checkValidMail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const handleInvite = async () => {
    if (!email) {
      setError("Email is required");
      return;
    }
    if (!checkValidMail(email)) {
      setError("Invalid email address");
      return;
    }
    setLoading(true);
    setError("");

    try {
      await axios.post(`${API_URL}/manager/invite_user`, {
        email,
        groupId: group_id || 0,
        manager_id,
      });

      setEmail("");
      if (onUserAdded) {
        await onUserAdded();
      }

      // Close the invite form right away
      if (onClose) onClose();

      // Show success notification independently
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
      }, 8000);
    } catch (error) {
      console.error("Error inviting user:", error);
      setError(
        error.response?.data?.message ||
          "Failed to invite user. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  const renderInviteForm = isOpen && (
    <Layer
      onEsc={onClose}
      onClickOutside={onClose}
      responsive
      modal
      position="center"
    >
      <Box pad="medium" gap="medium" width="medium">
        <Heading level="3" margin="none">
          Invite a User
        </Heading>
        <TextInput
          placeholder="Enter user email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
        {error && <Text color="status-critical">{error}</Text>}

        <Box
          direction="row"
          gap="small"
          justify="end"
          margin={{ top: "small" }}
        >
          <Button label="Cancel" onClick={onClose} />
          <Button label="Send Invite" onClick={handleInvite} primary />
        </Box>
      </Box>
    </Layer>
  );

  return (
    <>
      {renderInviteForm}

      {loading && (
        <Layer>
          <Box pad="medium" align="center" gap="small">
            <Spinner />
            <Text>Sending Invite...</Text>
          </Box>
        </Layer>
      )}

      {showSuccess && (
        <Notification
          toast
          status="normal"
          title="User Invited"
          message={
            <Text>
              The user was successfully invited.{" "}
              <Text
                as="span"
                color="brand"
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => navigate(`/${manager_id}/manager/users-groups`)}
              >
                Click here
              </Text>{" "}
              to view invited users.
            </Text>
          }
          onClose={() => setShowSuccess(false)}
        />
      )}
    </>
  );
};
